import { useParams } from "react-router-dom";
import { useStore } from "../store/StoreProvider";
import { AppPage } from "../utils/AppPage";
import { useMemo } from "react";
import { Box } from "@chakra-ui/react";
import { ActivityCardBig } from "./ActivityCardBig";

export const ActivityPage = () => {
  const { state } = useStore();
  const { activityId } = useParams();
  const currentActivity = useMemo(
    () => state.activityList.find((a) => String(a.id) === activityId),
    [activityId, state.activityList]
  );

  return (
    <AppPage title="Activity">
      {currentActivity ? (
        <ActivityCardBig activity={currentActivity} />
      ) : (
        <Box>Cannot find activity {activityId}</Box>
      )}
    </AppPage>
  );
};
